import {Box, CircularProgress} from "@mui/material";
import {OrderContainer} from "./OrderContainer";
import React, {useState, Fragment} from "react";

export const ConversionContainer = ({loading, conversionOrders}) => {
    const [selectedOrder, setSelectedOrder] = useState("")

    const toggleOrderDetails = (orderId) => {
        setSelectedOrder((prev) => {
            return prev === orderId ? "" : orderId
        })
    }

    return(
        <Box>
            <Box sx={{fontFamily: "FustatExtraBold", fontWeight: 600, color: "#302E2A", letterSpacing: "1px"}}>
                ORDER HISTORY
            </Box>

            { loading &&
                <Box sx={{height: '74px', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    <CircularProgress size={20} sx={{color: '#003300'}}/>
                </Box>
            }

            {!loading && conversionOrders?.orders &&
                <Box sx={{display: "flex", flexDirection: "column", gap: "14px", marginTop: '10px'}}>
                    { conversionOrders?.orders?.map((order, index) => (
                        <Fragment key={index}>
                            <OrderContainer selectedOrder={selectedOrder} order={order} toggleOrderDetails={toggleOrderDetails} />
                        </Fragment>
                    ))}
                </Box>
            }
        </Box>
    )
}
